import { useEffect, useMemo, useState } from 'react';
import { Buffer } from 'buffer';
import './index.css';
import r1 from '../../assets/images/r1.webp';
import r2 from '../../assets/images/r2.webp';

import letsconnectimage from '../../assets/images/letsconnect.webp'

interface IBotData {
  key: string;
  image: string;
}

const BOT_ITEMS: IBotData[] = [
  { key: 'truck', image: r1 },
  { key: 'cat', image: r2 },
];

const Contact = () => {
  const post_url =
    'https://vpnyyhv2cvl66gk4oguyebiimy0lzstt.lambda-url.us-east-1.on.aws/';

  const EXPECTED_API_KEY =
    process.env.REACT_APP_CONTACT_API_KEY ||
    '091cb55d-d130-4536-ab37-46a3f91e85dc';

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [botChoice, setBotChoice] = useState('');
  const [botStatus, setBotStatus] = useState('');
  const [botData, setBotData] = useState<IBotData | null>(null);

  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    custom_message: '',
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('success') === 'true') {
      setIsSubmitted(true);
    }

    const randomIndex = Math.floor(Math.random() * BOT_ITEMS.length);
    setBotData(BOT_ITEMS[randomIndex]);
  }, []);

  const formReady = useMemo(() => {
    return formData.fullname.trim().length > 0 && formData.email.trim().length > 0;
  }, [formData.fullname, formData.email]);

  const validateBot = () => {
    if (botChoice.trim().toLowerCase() === botData?.key) {
      setBotStatus('');
      return true;
    }

    setBotStatus('Incorrect answer. Please try again.');
    return false;
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!formReady) {
      setBotStatus('Please enter your name and email.');
      return;
    }

    if (!validateBot()) {
      return;
    }

    const form = document.forms.namedItem('contact') as HTMLFormElement | null;
    if (!form) {
      setBotStatus('Form not found.');
      return;
    }

    try {
      setBotStatus('Sending ...');

      const x_api_key = Buffer.from(EXPECTED_API_KEY, 'utf-8').toString('base64');
      const submittedFormData = new FormData(form);

      const formObject: Record<string, any> = {};
      submittedFormData.forEach((value, key) => {
        if (key === 'requested_services') {
          if (!formObject[key]) formObject[key] = [];
          formObject[key].push(value);
        } else {
          formObject[key] = value;
        }
      });

      const response = await fetch(post_url, {
        method: 'POST',
        body: JSON.stringify(formObject),
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': x_api_key,
        },
      });

      await response.json();

      if (response.ok) {
        setIsSubmitted(true);
        window.location.href = '/contact?success=true';
      } else {
        setBotStatus('Submit failure');
      }
    } catch (error) {
      console.log(error);
      setBotStatus('Submit failure');
    }
  };

  return (
    <div className="contact-page">
      {isSubmitted ? (
        <div className="success-card">
          <h1>Message received!</h1>
          <p>Thanks for reaching out. We will contact you soon.</p>
        </div>
      ) : (
        <div className="contact-shell">
          <section className="contact-hero">
            
            <div className="contact-hero-image-wrap">
                <img src={letsconnectimage} alt="Callout" className="contact-hero-image" /><br/>
                <h1>Let's Connect</h1>
            </div>
            <div className="contact-hero-content">
            <div className="contact-kicker-list">
                <span className="contact-kicker-pill">Custom 3D Prints</span>
                <span className="contact-kicker-pill">Websites</span>
                <span className="contact-kicker-pill">Creative Help</span>
            </div>
                <p className="contact-intro">
                Tell us what you need, whether it is a custom product, a website,
                consulting, tutoring, or something unique for your family or business.
                </p>
            </div>
          </section>

          <form name="contact" id="contact" className="contact-card">
            <div className="fields-grid">
              <div className="field">
                <label htmlFor="name">Your name</label>
                <input
                  type="text"
                  id="name"
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                  placeholder="Enter your name"
                />
              </div>

              <div className="field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                />
              </div>
            </div>

            <div className="field">
              <label htmlFor="custom_message">How can we help?</label>
              <textarea
                id="custom_message"
                rows={6}
                name="custom_message"
                value={formData.custom_message}
                onChange={handleChange}
                placeholder="Tell us about your project, question, or custom idea"
              />
            </div>

            <section className="section-card">
              <div className="section-header">
                <h2>What are you interested in?</h2>
                <p>Select one or more options below.</p>
              </div>

              <div className="chips-grid">
                <label className="chip-option" htmlFor="products">
                  <input type="checkbox" id="products" name="requested_services" value="products" />
                  <span>Products</span>
                </label>

                <label className="chip-option" htmlFor="website">
                  <input type="checkbox" id="website" name="requested_services" value="website" />
                  <span>Website</span>
                </label>

                <label className="chip-option" htmlFor="cloud-consulting">
                  <input
                    type="checkbox"
                    id="cloud-consulting"
                    name="requested_services"
                    value="cloud-consulting"
                  />
                  <span>Cloud</span>
                </label>

                <label className="chip-option" htmlFor="development">
                  <input
                    type="checkbox"
                    id="development"
                    name="requested_services"
                    value="development"
                  />
                  <span>Development</span>
                </label>

                <label className="chip-option" htmlFor="consulting">
                  <input type="checkbox" id="consulting" name="requested_services" value="consulting" />
                  <span>Consulting</span>
                </label>

                <label className="chip-option" htmlFor="support">
                  <input type="checkbox" id="support" name="requested_services" value="support" />
                  <span>Support</span>
                </label>

                <label className="chip-option" htmlFor="tutoring">
                  <input type="checkbox" id="tutoring" name="requested_services" value="tutoring" />
                  <span>Tutoring</span>
                </label>

                <label className="chip-option" htmlFor="other">
                  <input type="checkbox" id="other" name="requested_services" value="other" />
                  <span>Other</span>
                </label>
              </div>
            </section>

            <section className="section-card human-check-card">
              <div className="section-header">
                <h2>Quick human check</h2>
                <p>Type what is shown in the image.</p>
              </div>

              <div className="human-check-row">
                <div className="captcha-box">
                  <img src={botData?.image} alt="Captcha" className="botimage" />
                  <input
                    type="text"
                    id="botchoice"
                    maxLength={10}
                    value={botChoice}
                    onChange={(e) => setBotChoice(e.target.value)}
                    placeholder="Type answer"
                    className="captcha-input"
                  />
                </div>

                <button
                  type="button"
                  onClick={handleSubmit}
                  className={formReady ? 'button_enabled' : 'button_disabled'}
                >
                  Send Message
                </button>
              </div>

              <div className="status-row">
                <span className="botStatus">{botStatus}</span>
              </div>
            </section>
          </form>
        </div>
      )}
    </div>
  );
};

export default Contact;